export default {
  common: {
    button: {
      cancel: 'Abbrechen',
      clear: 'Löschen',
      close: 'Schließen',
      done: 'Fertig',
      getStarted: 'Loslegen',
      next: 'Weiter',
      ok: 'OK',
      logOut: 'Abmelden',
      register: 'Registrieren',
      reset: 'Zurücksetzen',
      update: 'Aktualisieren',
      leaveFeedback: 'Feedback geben',
      yes: 'Ja',
      no: 'Nein',
      switchUser: 'Benutzer wechseln'
    },
    connectivity: {
      offline: 'Offline',
      online: 'Online'
    },
    emoji: {
      bad: 'Schlecht',
      good: 'Gut',
      neutral: 'Neutral',
      perfect: 'Perfekt',
      worst: 'Schlechteste'
    },
    misc: {
      copyright: '© 125 Data & Insights Ltd',
      fibLtd: '125 Data & Insights Limited',
      findOutMore: 'Mehr erfahren',
      licenseInfo: 'Lizenzinformation',
      loading: 'Laden',
      miles: 'Meilen',
      privacyPolicy: 'Datenschutzerklärung der Plattform',
      total: 'Gesamt'
    },
    placeholder: {
      addYourComments: 'Ihre Kommentare hinzufügen...'
    },
    social: {
      email: 'E-Mail',
      facebook: 'Facebook',
      google: 'Google',
      tripadvisor: 'Tripadvisor',
      twitter: 'Twitter'
    },
    validation: {
      alphaNumDashes: 'Dieses Feld darf nur die Zeichen a-z, A-Z, Bindestriche, Unterstriche und Zahlen 0-9 enthalten.',
      alphaNumLower: 'Dieses Feld darf nur die Zeichen a-z und Zahlen 0-9 enthalten.',
      anniversary: 'Dieses Feld muss ein gültiges Datum im Format TT/MM enthalten',
      DDMM: 'Das Datum muss im Format Tag/Monat formatiert sein: (TT/MM)',
      DDMMYYYY: 'Das Datum muss im Format Tag/Monat/Jahr formatiert sein: (TT/MM/JJJJ)',
      email: 'Dieses Feld muss eine gültige E-Mail-Adresse enthalten',
      futureDateNotAllowed: 'Das Datum darf nicht in der Zukunft liegen',
      match: 'Dieses Feld muss einen übereinstimmenden Wert enthalten',
      max: 'Dieses Feld darf nicht mehr als {n} Zeichen enthalten',
      min: 'Dieses Feld muss mindestens {n} Zeichen enthalten',
      numeric: 'Dieses Feld darf nur Zahlen 0-9 enthalten',
      required: 'Erforderlich',
      validationFailed: 'Validierung fehlgeschlagen',
      validationSuccessful: 'Validierung erfolgreich',
      minValue: 'Wert muss {n} oder höher sein'
    }
  }
};